import {BaseOptions} from "../../../../dialog/options/base.options";

export interface DynamicField {
  label: string;
  type: 'text' | 'number' | 'email' | 'password' | 'textarea' | 'input' | 'file-chooser' | 'dropdown' | 'color' | 'editor' | 'checkbox' | 'object' | 'array';
  value?: any;
  required?: boolean;
  options?: any[];
  isMultiple?: boolean;
  objectFields?: DynamicField[]; // برای فیلدهای داخل آبجکت
  arrayFields?: DynamicField[]; // برای فیلدهای داخل آرایه
}

export class DetailsOptions extends BaseOptions {
  details?: any;
  fields?: DynamicField[] = [];
  onDetailsSelected = (details: any) => {
  };
}
